export default function initAnnouncementPanel() {
	const panel = document.querySelector('.js-announcement-panel');
	const mainEl = document.getElementById('wrapper');
	const header = document.querySelector('.header');

	if (!panel) {
		return;
	}

	function setPadding() {
		const height = panel.offsetHeight;
		const headerHeight = header.offsetHeight;
		mainEl.style.paddingTop = headerHeight + 'px';
		document.documentElement.style.setProperty('--announcement-section-height', `${height}px`);
		// mainEl.style.paddingTop = height + 'px';
	}

	setTimeout(function () {
		setPadding();
	}, 500);

	const announceId = panel.dataset.announceid;
	if(announceId){
		const dismiss = localStorage.getItem("dismiss");
		let dismissFlag = false;
		if(dismiss){
			const dismissArray = dismiss.split(',');
			dismissFlag = dismissArray.includes(announceId);
		}
		if(dismissFlag){
			panel.style.setProperty('display', 'none', 'important');
			setPadding();
		}else{
			panel.style.setProperty('display', 'block', 'important');
		}

		const dismissBtn = panel.querySelector('.dismiss');
		if(dismissBtn){
			dismissBtn.addEventListener('click', function(e){
				e.preventDefault();
				panel.style.setProperty('display', 'none', 'important');
				setPadding();
				if(dismiss){
					localStorage.setItem("dismiss", dismiss + ',' + announceId);
				}else{
					localStorage.setItem("dismiss", announceId);
				}
				window.dispatchEvent(new Event('resize'));
			});
		}
	}

	window.addEventListener('resize', setPadding);
}
